import { MenuItem, styled } from "@mui/material";

import { background, button } from "@/modules/irohana-components/theme/colors";

/** Shared menu item styling for Select and SelectMulti. */
export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    &:hover {
      background-color: ${background.primary} !important;
    }
    &.Mui-selected {
      color: ${button.primary};
      font-weight: 500;
      background-color: ${background.secondary} !important;
      &:hover,
      &.Mui-focusVisible {
        background-color: ${background.secondary} !important;
      }
    }
  }
`;
